module.exports = __webpack_public_path__ + "img/hero-background-geometric.b539c213.jpeg";